import { Card, CardContent, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If, Else } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { RemovedRow } from "./removed-row"

/**
 * Demands that were granted and then stripped, with the stage that stripped them.
 *
 * This section is what makes the tab trustworthy: without it, "Final state" would appear to
 * contradict "Granted" for no visible reason. It is also where the two silent failures surface
 * — a productDemand removed by DemandAudit, and a `feature-*` grant that does nothing because
 * the environment's server_demands setting does not list it.
 */
export function RemovedSection() {
    const { breakdown } = useBoundContext()
    const removed = breakdown.removed ?? []

    return (
        <Card data-cy="access-removed-section">
            <CardContent>
                <Stack spacing={1.5}>
                    <Typography variant="subtitle1">Removed</Typography>
                    <If value={removed.length > 0}>
                        <Table size="small" data-cy="access-removed-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell width={40} />
                                    <TableCell>Demand</TableCell>
                                    <TableCell>Removed by</TableCell>
                                    <TableCell>Granted by</TableCell>
                                    <TableCell />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <Repeat list={removed} item={<RemovedRow />} keyFn={keyOf} />
                            </TableBody>
                        </Table>
                        <Else>
                            <Typography variant="body2" color="text.secondary">
                                Nothing granted was removed downstream.
                            </Typography>
                        </Else>
                    </If>
                </Stack>
            </CardContent>
        </Card>
    )

    function keyOf(entry) {
        return entry.demand
    }
}
